import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { connect } from 'react-redux';
import { getAll as getProgramList } from 'actions/programs';
import ProgramList from './list';
import Search from 'modules/list/search-bar';

export class CurriculumAnalytics extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchKey: '',
      searchedProgramData: [],
    };
  }
  componentDidMount() {
    const { actions } = this.props;
    actions.getProgramList();
  }

  onSearch = Key => {
    const { searchKey } = this.state;

    if (Key !== searchKey && (searchKey || Key)) {
      this.setState({ searchKey: Key }, () => this.handleSearchData(Key));
    }
  };

  getprogramData = () => {
    const { programs } = this.props;
    const programList = store.getAll(programs);
    return programList && programList.data;
  };

  handleSearchData = searchKey => {
    const programData = this.getprogramData();

    const searchData = programData.filter(item => {
      const { code, name } = item || {};
      const lowerCaseCode = code && code.toLowerCase();
      const lowerCaseName = name && name.toLowerCase();
      const lowerCaseSearchKey = searchKey ? searchKey.toLowerCase() : null;

      return (
        lowerCaseCode.includes(lowerCaseSearchKey) ||
        lowerCaseName.includes(lowerCaseSearchKey)
      );
    });

    this.setState({
      searchedProgramData: searchData,
    });
  };

  render() {
    const programData = this.getprogramData();
    const { searchKey, searchedProgramData } = this.state;
    return (
      <>
        <Search onSearch={this.onSearch} placeholder="Search Program..." />
        <ProgramList
          programsList={searchKey ? searchedProgramData : programData}
          searchKey={searchKey}
        />
      </>
    );
  }
}

CurriculumAnalytics.propTypes = {
  actions: PropTypes.shape({
    getProgramList: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(
  ({ programs }) => ({
    programs,
  }),
  dispatch => ({
    actions: bindActionCreators({ getProgramList }, dispatch),
  }),
)(CurriculumAnalytics);
